<script lang="ts" setup>
import type { Business } from '../types/business';
import { computed } from 'vue';
const props = defineProps<{
  business: Business;
}>();
const isOpen = computed(() =>
  props.business.isOpenNow ? 'Geöffnet' : 'Geschlossen',
);
const query = computed(() => {
  const a = props.business.address;
  return encodeURIComponent(
    `${a.line1},${a.postalCode},${a.city},${a.countryCode}`,
  );
});
</script>
<template>
  <a :href="business.url" target="_self">
    <div class="flex flex-col gap-x-6 gap-y-8 mc:flex-row">
      <div>
        <div
          class="business-image"
          :style="`background-image: url(${props.business.mainImage.url}); background-repeat: no-repeat; background-size: cover; background-position: center;`"
        >
          <div
            class="business-status"
            :class="
              props.business.isOpenNow
                ? 'business-status--open'
                : 'business-status--closed'
            "
          >
            <span
              ><i
                class="mr-2"
                :class="props.business.isOpenNow ? 'door-open' : 'door-closed'"
              ></i
              >{{ isOpen }}</span
            >
          </div>
        </div>
      </div>
      <div class="flex w-full flex-col gap-y-4 text-lg font-normal">
        <p>{{ business.address.line1 }}</p>
        <p class="text-2xl font-extrabold uppercase">{{ business.title }}</p>
        <div>
          <p v-for="category in business.categories">
            <i class="apple-arrow mr-2 text-primary-900"></i>{{ category }}
          </p>
          <p v-if="business.acceptsVoucher" class="text-nowrap">
            Gutschein einlösbar<i
              class="voucher-icon ml-2 text-primary-900"
            ></i>
          </p>
        </div>

        <div class="mt-auto flex items-end border-y-[1px] border-secondary">
          <a
            target="_blank"
            :href="`https://www.google.com/maps/search/?api=1&query=${query}`"
            class="flex w-full items-center justify-between py-2"
            ><span class="font-bold"
              ><i class="pin-icon mr-2"></i>Google Maps öffnen</span
            ><i class="external-link"></i
          ></a>
        </div>
      </div>
    </div>
  </a>
</template>

<style lang="scss" scoped>
.business-image {
  @apply w-[420px] m:w-full;
  aspect-ratio: 1.4;
  background: center, no-repeat, cover;
  position: relative;
  border-radius: 1rem;
}

.business-status {
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  padding: 0.5rem 0.75rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 1rem;
  z-index: 10;
  border-radius: 0.6rem;

  &--open {
    background-color: #e2e2e3;
    border: 2px solid #e2002a;
    color: black;
  }

  &--closed {
    background-color: #e2002a;
    color: white;
  }
}
</style>
